/**
|--------------------------------------------------
| THIS COMPONENT HAS REBUILD on 1-april-2019
|--------------------------------------------------
*/
import React from "react";
import moment from "moment";
import DateRangePicker from "react-daterange-picker";
import classnames from "classnames";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";

import Request from "config/Request.js";
// Component
import TabTracking from "../../../../asset/simple_asset/helper/component/Tab/TabTracking.js";
import TabMaintenance from "../../../../asset/simple_asset/helper/component/Tab/TabMaintenance.js";
import TabPurchase from "../../../../asset/simple_asset/helper/component/Tab/TabPurchase.js";
import TabNotes from "../../../../asset/simple_asset/helper/component/Tab/TabNotes.js";
import NoAssetImage from "../../../../views/assets/global/img/no-asset-image.jpg";
import Logo from "../../../../views/assets/global/img/AssetVault_logo_80.jpg";

// TOAST
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import QRCode from "../../../../qrreader/helper/component/QRGenerator.js";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactImageMagnify from "react-image-magnify";

import Lib from "utils/Lib.js";

const SliderSetting = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
};

let stateDefinitions = {
  available: {
    selectable: false,
    color: null,
    label: "Available"
  },
  unavailable: {
    selectable: false,
    color: "#78818b",
    label: "Not available"
  },
  yours: {
    selectable: false,
    color: "#ffd200",
    label: "Your booking"
  }
};

export default class ModalDetailAsset extends React.Component {
  constructor(props) {
    super(props);

    this.initialState = {
      activeTab: 1,
      firstTimeLoad: {
        1: true
      },
      SelectedItem: null,
      value: null,
      disabledBook: true,
      dateRanges: [],
      assetDetail: {
        Photos: []
      }
    };
    this.state = Object.assign({}, this.initialState);
    this.toggleTab = this.toggleTab.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.onLoadDetail = this.onLoadDetail.bind(this);
    this.onLoadDetailSuccess = this.onLoadDetailSuccess.bind(this);
    this.onLoadDetailFailed = this.onLoadDetailFailed.bind(this);

    this.onLoadReservation = this.onLoadReservation.bind(this);
    this.onLoadReservationSuccess = this.onLoadReservationSuccess.bind(this);

    this.onLoadFailed = this.onLoadFailed.bind(this);

    this.selected = null;
    this.tempVars = {};
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        firstTimeLoad: {
          ...this.state.firstTimeLoad,
          [tab]: true
        }
      });
    }
  }

  handleSelect(range, states) {
    let disabled = true,
      max_day_in_ms = 1000 * 60 * 60 * 24 * this.state.assetDetail.MaxDay,
      date_range_in_ms = range.end - range.start;

    if (date_range_in_ms > max_day_in_ms) {
      toast.error(
        "Maximum book duration is " + this.state.assetDetail.MaxDay + " days"
      );
      disabled = true;
    } else {
      disabled = false;
    }
    this.setState({
      value: range,
      states: states,
      disabledBook: disabled
    });
  }

  /**
  |--------------------------------------------------
  | REQUEST
  |--------------------------------------------------
  */
  onLoadDetail(alias) {
    Request(
      "get",
      "read-asset-detail",
      { Authorization: "Bearer " + this.props.UserReducer.token },
      {},
      [alias],
      this.onLoadDetailSuccess,
      this.onLoadDetailFailed,
      alias
    );
  }

  onLoadDetailSuccess(response, extra) {
    this.setState({
      assetDetail: response.data
    });
    this.onLoadReservation(extra);
  }

  onLoadDetailFailed(error) {
    toast.error("Asset not found / deleted!");
    this.props.CloseModal();
  }

  onLoadReservation(alias) {
    Request(
      "get",
      "read-asset-reservation",
      { Authorization: "Bearer " + this.props.UserReducer.token },
      {},
      [alias],
      this.onLoadReservationSuccess,
      this.onLoadFailed
    );
  }

  onLoadReservationSuccess(response) {
    let booklist = [];
    for (let i = 0; i < response.data.length; i++) {
      let bookstate = "unavailable";
      if (response.data[i].User.Username === this.props.UserReducer.username) {
        bookstate = "yours";
      }
      booklist.push({
        state: bookstate,
        range: moment.range(
          moment(response.data[i].StartDate),
          moment(response.data[i].FinishDate)
        )
      });
    }
    this.setState({ dateRanges: booklist });
  }

  onLoadFailed() {}

  componentWillReceiveProps(nextProps) {
    this.tempVars = {};
    if (nextProps.isUpdateReservation) {
      this.onLoadReservation(nextProps.SelectedItems.Alias);

      // console.log(nextProps)
      // let booklist = [];
      // booklist.push({
      //   'state': 'yours',
      //   'range': moment.range(
      //     moment(nextProps.dateBookingStart_UTC).format('YYYY-MM-DD'),
      //     moment(nextProps.dateBookingEnd_UTC).format('YYYY-MM-DD'),
      //   )
      // })
      // this.setState({
      //   dateRanges: [...this.state.dateRanges, ...booklist],
      //   // valueDate: '',
      // })

      /**
      |--------------------------------------------------
      | reason use reset_date_selected, value date rangepicker sometime error in null,
      | but for now is fixed
      |--------------------------------------------------
      */
      // let reset_date_selected = moment.range(
      //   moment().subtract(3, 'days').format('YYYY-MM-DD'),
      //   moment().subtract(4, 'days').format('YYYY-MM-DD'),
      // )
      this.tempVars = {
        ...this.tempVars,
        disabledBook: true,
        value: null
      };
      nextProps.setIsUpdateReservation(false);
    }
    this.tempVars = {
      ...this.tempVars,
      SelectedItem: nextProps.SelectedItems
    };
    this.setState(this.tempVars);
  }

  willMount() {
    if (this.props.SelectedItems)
      this.onLoadDetail(this.state.SelectedItem.Alias);
    if (this.props.allowBooking) {
      stateDefinitions.available.selectable = this.state.SelectedItem.CanBook;
    }
  }

  RenderImage() {
    let imageList = [];

    let image = this.state.assetDetail.Photos;

    if (image.length === 0) {
      return (
        <img className="img-null-owl" src={NoAssetImage} alt="placeholder" />
      );
    } else {
      for (let i = 0; i < image.length; i++) {
        imageList.push(
          <div key={i}>
            <ReactImageMagnify
              {...{
                smallImage: {
                  alt: image[i].Alias,
                  isFluidWidth: true,
                  src: `${image[i].URL}&token=${this.props.UserReducer.token}`,
                  width: 300,
                  height: 450
                },
                largeImage: {
                  src: `${image[i].URL}&token=${this.props.UserReducer.token}`,
                  width: 1200,
                  height: 1800
                },
                enlargedImageContainerDimensions: {
                  width: "200%",
                  height: "100%"
                },
                enlargedImagePosition: "over",
                className: "img-responsive-slick",
                isHintEnabled: true
              }}
            />
          </div>
        );
      }
    }
    return imageList;
  }

  renderTabDetail() {
    return (
      <div className="row">
        <div className="col-lg-5">
          <div className="col-md-12 hidden-lg-up">
            <div className="list-separator">
              <div className="item-inner">QR Code</div>
            </div>
            <div className="m-top-15">
              <QRCode
                value={JSON.stringify({
                  type: "asset",
                  value: this.state.assetDetail.Alias
                })}
                logo={Logo}
                logoWidth={50}
                size={150}
                customSize={"100%"}
              />
            </div>
            <div className="cell-spacer" />
          </div>
          <div className="col-md-10 offset-md-1 col-lg-12 offset-lg-0">
            <div className="list-separator hidden-lg-up">
              <div className="item-inner">Asset Image</div>
            </div>
            <div className="m-top-15 hidden-lg-up" />
            <Slider {...SliderSetting}>{this.RenderImage()}</Slider>
            <div className="cell-spacer" />
          </div>
          <div className="col-md-12">
            <div className="list-separator">
              <div className="item-inner">Reservation</div>
            </div>
            <DateRangePicker
              firstOfWeek={1}
              numberOfCalendars={1}
              selectionType="range"
              minimumDate={new Date()}
              stateDefinitions={stateDefinitions}
              dateStates={this.state.dateRanges}
              defaultState="available"
              showLegend={true}
              value={this.state.value}
              onSelect={this.handleSelect}
            />
            {this.props.allowBooking && (
              <button
                className={
                  this.state.disabledBook
                    ? "btn btn-block btn-default"
                    : "btn btn-block btn-primary"
                }
                onClick={() => this.props.toggleModalBooking(this.state.value)}
                disabled={this.state.disabledBook}
              >
                Book Now
              </button>
            )}
          </div>
        </div>
        <div className="col-lg-7">
          <div className="list-separator">
            <div className="item-inner">Asset Information</div>
          </div>
          <ListGroup>
            <ListGroupItem className="list-border-bottom">
              <div className="col-md-5">
                <strong className="spaceRRR">Asset</strong>
              </div>
              <div className="col-md-7">
                <span className="break-word">
                  {Lib.replaceEmpty(this.state.assetDetail.Name)}
                </span>
              </div>
            </ListGroupItem>
            <ListGroupItem className="list-border-bottom">
              <div className="col-md-5">
                <strong className="spaceRRR">Serial Number</strong>
              </div>
              <div className="col-md-7">
                <span className="break-word">
                  {Lib.replaceEmpty(this.state.assetDetail.SerialNumber)}
                </span>
              </div>
            </ListGroupItem>
            {/*<ListGroupItem className="list-border-bottom">
              <div className="col-md-4">
                <strong className="spaceRRR">Alias</strong>
              </div>
              <div className="col-md-8">
                <span className="break-word">{Lib.replaceEmpty(this.state.assetDetail.Alias)}</span>
              </div>
            </ListGroupItem>*/}
            <ListGroupItem className="list-border-bottom">
              <div className="col-md-5">
                <strong className="spaceRRR">Due Date</strong>
              </div>
              <div className="col-md-7">
                <span className="break-word">
                  {this.state.assetDetail.DueDate
                    ? moment(this.state.assetDetail.DueDate).format("ll")
                    : "-"}
                </span>
              </div>
            </ListGroupItem>
            <ListGroupItem className="list-border-bottom">
              <div className="col-md-5">
                <strong className="spaceRRR">Tag</strong>
              </div>
              <div className="col-md-7">
                <span className="break-word">
                  {Lib.replaceEmpty(this.state.assetDetail.Tag)}
                </span>
              </div>
            </ListGroupItem>
            <ListGroupItem className="list-border-bottom">
              <div className="col-md-5">
                <strong className="spaceRRR">Status</strong>
              </div>
              <div className="col-md-7">
                <span className="break-word">
                  {Lib.replaceEmpty(this.state.assetDetail.Status)}
                </span>
              </div>
            </ListGroupItem>
            <ListGroupItem className="list-border-bottom">
              <div className="col-md-5">
                <strong className="spaceRRR">Type</strong>
              </div>
              <div className="col-md-7">
                <span className="break-word">
                  {Lib.replaceEmpty(this.state.assetDetail.Type)}
                </span>
              </div>
            </ListGroupItem>
            <ListGroupItem className="list-border-bottom">
              <div className="col-md-5">
                <strong className="spaceRRR">Site</strong>
              </div>
              <div className="col-md-7">
                <span className="break-word">
                  {Lib.replaceEmpty(this.state.assetDetail.Site)}
                </span>
              </div>
            </ListGroupItem>
            <ListGroupItem className="list-border-bottom">
              <div className="col-md-5">
                <strong className="spaceRRR">Location</strong>
              </div>
              <div className="col-md-7">
                <span className="break-word">
                  {Lib.replaceEmpty(this.state.assetDetail.Location)}
                </span>
              </div>
            </ListGroupItem>
            <ListGroupItem className="list-border-bottom">
              <div className="col-md-5">
                <strong className="spaceRRR">Max Days</strong>
              </div>
              <div className="col-md-7">
                <span className="break-word">
                  {Lib.replaceEmpty(this.state.assetDetail.MaxDay)}
                </span>
              </div>
            </ListGroupItem>
            <ListGroupItem className="list-border-bottom">
              <div className="col-md-5">
                <strong className="spaceRRR">Owner</strong>
              </div>
              <div className="col-md-7">
                <span className="break-word">
                  {Lib.replaceEmpty(this.state.assetDetail.Owner)}
                </span>
              </div>
            </ListGroupItem>
            <ListGroupItem className="list-border-bottom">
              <div className="col-md-12">
                <strong className="spaceRRR">Description</strong>
              </div>
              <div className="col-md-12">
                <span className="break-word">
                  {Lib.replaceEmpty(this.state.assetDetail.Description)}
                </span>
              </div>
            </ListGroupItem>
            <ListGroupItem className="list-border-bottom hidden-md-down no-border">
              <div className="col-md-12">
                <strong className="spaceRRR">QR Code</strong>
              </div>
              <div className="col-md-12 offset-md-4">
                <QRCode
                  value={JSON.stringify({
                    type: "asset",
                    value: this.state.assetDetail.Alias
                  })}
                  logo={Logo}
                  logoWidth={30}
                  customSize={150}
                />
              </div>
            </ListGroupItem>
          </ListGroup>
        </div>
      </div>
    );
  }

  resetActiveTab = () => {
    this.setState(this.initialState);
  };

  // renderNavItem() {
  //   const item =  {}

  //   return(
  //     <NavItem>
  //       <NavLink className={classnames({ active: activeTab === 1 })} onClick={() => { this.toggleTab(1); }} >
  //         Asset Detail
  //       </NavLink>
  //     </NavItem>
  //   )

  // }

  render() {
    const { activeTab, firstTimeLoad } = this.state;
    if (!this.state.SelectedItem) {
      return null;
    }

    return (
      <Modal
        isOpen={this.props.ModalState}
        toggle={() => this.props.CloseModal()}
        onExit={() => this.resetActiveTab()}
        onEnter={() => this.willMount()}
        className="modal-lg"
      >
        <ModalHeader toggle={() => this.props.CloseModal()}>
          {this.state.assetDetail.Name}
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12 m-top-15">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 1 })}
                    onClick={() => {
                      this.toggleTab(1);
                    }}
                  >
                    Asset Detail
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 2 })}
                    onClick={() => {
                      this.toggleTab(2);
                    }}
                  >
                    Tracking
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 3 })}
                    onClick={() => {
                      this.toggleTab(3);
                    }}
                  >
                    Maintenance
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 4 })}
                    onClick={() => {
                      this.toggleTab(4);
                    }}
                  >
                    Notes
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 5 })}
                    onClick={() => {
                      this.toggleTab(5);
                    }}
                  >
                    Purchase
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent className="" activeTab={this.state.activeTab}>
                <TabPane tabId={1}>
                  <div className="">{this.renderTabDetail()}</div>
                </TabPane>
                <TabPane tabId={2}>
                  <div className="">
                    {firstTimeLoad[2] && (
                      <TabTracking
                        UserReducer={this.props.UserReducer}
                        SelectedItem={this.state.assetDetail}
                      />
                    )}
                  </div>
                </TabPane>
                <TabPane tabId={3}>
                  <div className="">
                    {firstTimeLoad[3] && (
                      <TabMaintenance
                        usedFor={"inUser"}
                        UserReducer={this.props.UserReducer}
                        SelectedItem={this.state.assetDetail}
                      />
                    )}
                  </div>
                </TabPane>
                <TabPane tabId={4}>
                  <div className="">
                    {firstTimeLoad[4] && (
                      <TabNotes
                        UserReducer={this.props.UserReducer}
                        SelectedItem={this.state.assetDetail}
                      />
                    )}
                  </div>
                </TabPane>
                <TabPane tabId={5}>
                  <div className="">
                    {firstTimeLoad[5] && (
                      <TabPurchase
                        SelectedItem={this.state.assetDetail}
                        UserReducer={this.props.UserReducer}
                      />
                    )}
                  </div>
                </TabPane>
              </TabContent>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            onClick={() => this.props.CloseModal()}
            className="btn btn-danger"
          >
            Close
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/home/helper/component/Modal/ModalDetailMyAsset.js